import { types } from "../types/types";

const initialState = {
  cargada: false,
  loading: false,
  error: null,
  tab: 0,
  familiarSeleccionado: {},
  documentacionCompleta:false,
  familiarAfiliadoSeleccionado: {},
  familiarStagePreafiliadoSeleccionado: {},
};

export const familiarSeleccionadoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.grupoFamiliarPreinscriptoSeleccion:
      return {
        ...state,
        loading: true,
        error: null,
        familiarSeleccionado:action.payload,
        cargada: true,
      };
    
    case types.grupoFamiliarStagePreinscriptoSeleccion:
      return {
        ...state,
        familiarStagePreafiliadoSeleccionado:action.payload
      }
    case types.familiarSeleccionadoAfiliado:
    return {
      ...state,
      familiarAfiliadoSeleccionado:action.payload,
    };
    case types.grupoFamiliarLimpiarSeleccionado:
      return {
        ...state,
        loading: true,
        error: null,
        familiarSeleccionado:{},
        cargada: true,
        documentacionCompleta:false,
        familiarAfiliadoSeleccionado: {},
        familiarStagePreafiliadoSeleccionado: {},
      };
    case types.documentacionFamiliarPreafiliadoChange:
      return {
        ...state,
        documentacionCompleta:action.payload
      };
    case types.grupoFamiliarSetTab:  
      return {
        ...state,
        tab: action.payload
      };
    default:
      return state;
  }
};
